theme.headerSearch = (function () {
  function searchOverlay(e) {
    const input = e.querySelector('input[type="search"]');
    const headerSectin = document.querySelector(".section-header");
    const header = document.querySelector(".header__area");
    const headerRect = header.getBoundingClientRect();
    const overlayClass = document.querySelector(".offcanvas-overlay");
    document.documentElement.style.setProperty(
      "--header-height",
      `${header.clientHeight}px`
    );

    overlayClass.addEventListener("click", (event) => {
      document.body.classList.remove("overflow-hidden");
    });

    let quickDrawer = (trigger, closeTrigger, wrapper) => {
      let offcanvasSearchTrigger = document.querySelectorAll(trigger),
        offcanvasSidebarSearch = document.querySelector(wrapper),
        offcanvasSearchClose = document.getElementById(closeTrigger);

      offcanvasSearchTrigger.forEach((singleTrigger) => {
        if (singleTrigger) {
          singleTrigger.addEventListener("click", (event) => {
            event.preventDefault();

            const eventTarget = event.target;
            const infoDrawer = eventTarget.closest(
              ".information--drawer__trigger"
            );

            if (infoDrawer) {
              offcanvasSidebarSearch.classList.add("active");
              document.body.classList.add("overflow-hidden"); // ✅ overflow hidden add
            } else {
              offcanvasSidebarSearch.classList.add("active");
              document.body.classList.add("overflow-hidden");
              offcanvasSidebarSearch.addEventListener(
                "transitionend",
                () => {
                  trapFocus(offcanvasSidebarSearch);
                  trapFocus(input);
                },
                { once: true }
              );
            }
          });

          offcanvasSidebarSearch.addEventListener("keyup", (evt) => {
            if (evt.code === "Escape") {
              offcanvasSidebarSearch.classList.remove("active");
              removeTrapFocus(singleTrigger);
              document.body.classList.remove("overflow-hidden"); // ✅ remove on ESC
            }
          });

          if (offcanvasSearchClose) {
            offcanvasSearchClose.addEventListener("click", (event) => {
              event.preventDefault();
              offcanvasSidebarSearch.classList.remove("active");
              removeTrapFocus(singleTrigger);
              document.body.classList.remove("overflow-hidden"); // ✅ remove on close
            });
          }
        }
      });

      if (offcanvasSidebarSearch) {
        document.addEventListener("click", function (event) {
          let eventTarget = event.target;
          if (
            !eventTarget.closest(
              "#predictive__search_overlay, #quick__information_overlay"
            ) &&
            !eventTarget.closest(
              ".header__actions_btn--search, .information--drawer__trigger"
            )
          ) {
            offcanvasSidebarSearch.classList.remove("active");
            document.body.classList.remove("overflow-hidden"); // ✅ remove on outside click
          }
        });
      }
    };

    quickDrawer(
      ".header__actions_btn--search",
      "search__close_btn",
      "#predictive__search_overlay"
    );

    quickDrawer(
      ".information--drawer__trigger",
      "quick__information--close_btn",
      "#quick__information_overlay"
    );
  }
  return searchOverlay;
})();
